import { colors } from './styles/utilities/settings';

export const keyObjects = [
  {
    title: 'Low Risk',
    range: '< 30',
    color: colors.green,
  },
  {
    title: 'Medium Risk',
    range: '30-60',
    color: colors.yellow,
  },
  {
    title: 'High Risk',
    range: '> 60',
    color: colors.red,
  },
];

export const questions = [
  {
    icon: 'mouse',
    copy:
      'Mice can enter a building in an opening as small as 1/4 inch or as small as a quarter.',
  },
  {
    icon: 'roach',
    copy:
      'One pair of cockroaches can infest your facility with over 1 million offspring in less than a year.',
  },
  {
    icon: 'fly',
    copy:
      'Large flies carry more than 200 pathogens including Salmonella and E.Coli.',
  },
];

export const industries = [
  {
    label: 'Buildings, Facilities, Schools, and Government',
    name: 'Seg1 Hospitality',
    code: 'EDUC & GOVMNT',
  },
  {
    label: 'Food & Beverage Manufacturing',
    name: 'Seg2 Food & Beverage',
    code: 'FOOD PROCESS',
  },
  {
    label: 'Food Retail Service',
    name: 'seg3 Food Retails',
    code: 'FOOD RETAIL',
  },
  {
    label: 'Foodservice, Restaurant',
    name: 'seg4 Restaurants',
    code: 'FOOD SERVICE',
  },
  {
    label: 'Healthcare',
    name: 'Seg1 Hospitality',
    code: 'HLTHCARE',
  },
  {
    label: 'Hospitality',
    name: 'Seg1 Hospitality',
    code: 'HOSPITALITY',
  },
  {
    label: 'Manufacturing',
    name: 'Seg2 Food & Beverage',
    code: 'MANUFACTURING',
  },
  {
    label: 'Quick Service Restaurant',
    name: 'seg4 Restaurants',
    code: 'QSR',
  },
  {
    label: 'Retail',
    name: 'seg3 Food Retails',
    code: 'RETAIL NON FOOD',
  },
];

export const factors = [
  [
    'Thrive in hard-to-reach cracks and crevices that offer warmth and humidity.',
    'Breed and feed in unsanitary conditions',
    'Requires the indoor human habitat to survive',
  ],
  [
    'Garbage spillage, standing water, weeds/excessive vegetation',
    'Overgrown trees, holes and gaps around pipes and doors',
    'Product spillage, hidden runways and harborages'
  ],
  [
    'Dirty garbage area, open garbage receptacles',
    'Open doors and windows',
    'Food source - decaying material, garbage and food preparation'
  ],
  [
    'Dirty floors and drains',
    'Open doors and windows',
    'Perishables out in the open'
  ],
]

export const additionalPests = [
  {
    label: 'Bed Bugs',
    icon: '/media/PNG_bed_bug_gray.png',
    items: [
      'Not from a sanitation issue – carried from place to place',
      'Need access to humans - live in mattress seams and edges',
      'Look for blood stains and fecal spots',
    ],
  },
  {
    label: 'Ants',
    icon: '/media/PNG_ant_gray.png',
    items: [
      'Large variety with some nesting indoors and others outdoors',
      'Once food is found inside large numbers can be recruited',
      'Sanitation is key inside; landscape management is key outside',
    ],
  },
  {
    label: 'Birds',
    icon: '/media/PNG_bird_gray.png',
    items: [
      'Nesting, roosting and loafing opportunities increase pressure',
      'Feed on most foods including garbage and food scraps',
      'Smart, mobile animals can take advantage of sanitation gaps',
    ],
  },
  {
    label: 'Occasional Invaders',
    icon: '/media/PNG_occasional invader_gray.png',
    items: [
      'Landscape practices can produce high pressure on structures',
      'Gaps under doors allow invasion',
      'Monitor inside and fix the problem outside',
    ],
  },
  {
    label: 'Stored Product Pests',
    icon: '/media/PNG_stored-product-pests_gray.png',
    items: [
      'Usually brought in as a product infestation',
      'First In, First Out (FIFO) is critical',
      'Find the infested material, work closely with vendors',
    ],
  },
]
